
/**
 * Configuration constants for admin state management
 * Optimized for better multi-device synchronization
 */

// Caching settings - increased TTL to reduce database reads
export const STATE_CACHE_TTL = 60000; // 60 seconds (increased from 30)
export const MAX_ADMINS_TO_KEEP = 50;

// Batching and throttling settings - increased delay to reduce writes
export const UPDATE_DELAY = 5000; // 5 seconds batch window for updates (increased from 2)
export const SUPABASE_TABLE = 'admin_state';
export const DEFAULT_ID = 1;

// Attendees settings
export const MAX_ATTENDEES = 50; // Maximum number of attendees to keep

// Default admin state
export const createDefaultState = () => ({
  lastActivity: new Date().toISOString(),
  activeAdmins: [],
  lastSync: new Date().toISOString()
});

// Supabase endpoint for direct API access
export const SUPABASE_ENDPOINT = 'https://qfxvvnnqeewyrmqujgrf.supabase.co/rest/v1/admin_state';
